import React from "react";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Mui
import constant from "@/config/constant";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Fade from "@mui/material/Fade";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

// Mui Styles
import { StyledButton, StyledPaper } from "@/styles/mui/globalStyles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";

// CK Editor
import CKimageUploader from "@/components/CKimageUploader";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
// Fetch
import { createOrUpdateNotice, getNoticeByNoticeId } from "@/fetch/fetchNotice";
import { useCurrentAction } from "@/hooks/user";
import _ from "lodash";
const NoticeDetailPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  const { id } = useParams();

  // Navigate
  const navigate = useNavigate();

  // States
  const [onChangeData, setOnChangeData] = React.useState({
    region_ids: [1, 2],
  });
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);

  // Submit
  const onClickSubmit = async (id) => {
    if (onChangeData.title && onChangeData.content && onChangeData.status) {
      await createOrUpdateNotice(onChangeData, id).then((data) => {
        if (data && data.results) {
          if (id) {
            setSnackMessage("修改成功");
            setSnackOpen(true);
            setTimeout(() => {
              navigate("/notice");
            }, 500);
          } else {
            setSnackMessage("新增成功");
            setSnackOpen(true);
            setTimeout(() => {
              navigate("/notice");
            }, 500);
          }
        }
      });
    } else {
      setSnackMessage("請填寫資料");
      setSnackOpen(true);
    }
  };

  // Fetch all
  const fetchAll = async () => {
    await getNoticeByNoticeId(id).then((data) => {
      if (data && data.results) {
        let tempObj = {
          title: data.data[0].title,
          content: data.data[0].content,
          status: data.data[0].status.toString(),
          region_ids: data.data[0].region_ids,
        };
        setOnChangeData({ ...tempObj });
        setSlideTranOn(true);
      }
    });
  };
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            marginBottom: 10,
          },
        },
      },
    },
  });

  React.useEffect(() => {
    if (id) {
      fetchAll();
    } else {
      setOnChangeData({
        content: "",
        title: "",
        status: "",
        region_ids: [1, 2],
      });
      setSlideTranOn(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="NoticeDetailPage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      selectedIndex={2}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`內部公告 / ${id ? "修改公告" : "新增公告"}`}
        history={() => navigate(-1)}
      />
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>
          <Box
            noValidate
            sx={{ display: "flex", width: "100%", flexDirection: "column" }}
          >
            <ThemeProvider theme={theme}>
              <Grid container spacing={2}>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6
                  }}>
                  <TextField
                    disabled={!actions?.update}
                    id="outlined-name"
                    name="title"
                    label="標題"
                    error={onChangeData.title ? false : true}
                    value={onChangeData.title}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  />
                </Grid>

                <Grid
                  size={{
                    xs: 12,
                    md: 3,
                    lg: 3
                  }}>
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel id="select-brands-label">區域</InputLabel>
                    <Select
                      disabled={!actions?.update}
                      required
                      multiple
                      id="region_ids"
                      name="region_ids"
                      label="員工購物"
                      labelId="select-brands-label"
                      renderValue={(selected) => {
                        const selectedValue = _.map(selected, (s) => {
                          return constant.regionType[s];
                        });
                        return selectedValue.join(", ");
                      }}
                      onChange={(event) =>
                        setOnChangeData({
                          ...onChangeData,
                          [event.target.name]: event.target.value.sort(),
                        })
                      }
                      value={onChangeData.region_ids}
                    >
                      {_.map(constant.regionType, (value, key) => {
                        return (
                          <MenuItem value={parseInt(key)} key={key}>
                            <Checkbox
                              checked={onChangeData.region_ids.includes(
                                parseInt(key)
                              )}
                            />
                            <ListItemText primary={value} />
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 3,
                    lg: 3
                  }}>
                  <TextField
                    disabled={!actions?.update}
                    id="outlined-select"
                    select
                    label="選擇狀態"
                    name="status"
                    error={onChangeData.status ? false : true}
                    value={onChangeData.status}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value={""}>請選擇</MenuItem>
                    <MenuItem value={"false"}>草稿</MenuItem>
                    <MenuItem value={"true"}>發佈</MenuItem>
                  </TextField>
                </Grid>
              </Grid>

              <CKEditor
                disabled={!actions?.update}
                editor={ClassicEditor}
                config={{
                  extraPlugins: [CKimageUploader],
                }}
                data={onChangeData.content}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setOnChangeData({
                    ...onChangeData,
                    content: data,
                  });
                }}
              />
            </ThemeProvider>
            {actions?.update && (
              <StyledButton
                disabled={!actions?.update}
                variant="contained"
                size="small"
                onClick={() => onClickSubmit(id ? id : 0)}
              >
                <Typography variant="subtitle1" noWrap component="div">
                  確認
                </Typography>
              </StyledButton>
            )}
          </Box>
        </StyledPaper>
      </Fade>
    </Layout>
  );
};

export default NoticeDetailPage;
